<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="835"
      :before-close="() => cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <component
          :is="view"
          :tskInfoNo="tskInfoNo"
          :billNo="billNo"
          :disabled.sync="disabled"
          ref="main"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="save()"
          v-if="view && !disabled"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ this.$l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ this.$l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectionQuotation from '@/views/digital/customerManage/selectionQuotation/components/edit-form'
export default {
  components: { SelectionQuotation },
  props: {
    visible: { type: Boolean, default: false },
    tskInfoNo: { type: String, default: '' },
    todoTypeKey: { type: String, default: '' },
    title: { type: String, default: '' },
    billNo: { type: String, default: '' },
  },
  data() {
    return {
      componentMap: { 'Product-Quotation': SelectionQuotation },
      backDialogVisible: false,
      disabled: true,
    }
  },
  computed: {
    view() {
      if (!this.todoTypeKey) return
      return this.componentMap[this.todoTypeKey]
    },
  },
  methods: {
    async save() {
      // 组件需要提供一个保存方式，并返回保存接口结果的body
      const $main = this.$refs.main
      if (!$main) return

      const result = await $main.save()
      if (!result) return (this.backDialogVisible = false)

      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (!this.view || this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 20px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
